import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ProductSliderSection from '../common/ProductSliderSection'
import { getHomepageConfig } from '../../services/homepage.service'
import { productService } from '../../services/product.service'

const BestsellersSection = () => {
    const { t } = useTranslation();
    const [bestsellers, setBestsellers] = useState([]);
    const [loading, setLoading] = useState(true);

    // FETCH BESTSELLERS
    useEffect(() => {
        const fetchBestsellers = async () => {
            try {
                // 1. Get Config
                const config = await getHomepageConfig();
                console.log("[BestSellers] Config loaded:", config);
                const selectedIds = config.bestSellersProductIds || [];
                console.log("[BestSellers] Admin selected IDs:", selectedIds);

                let validProducts = [];

                // 2. If Admin Selected IDs exist
                if (selectedIds.length > 0) {
                    const promises = selectedIds.map(id => productService.getProductById(id));
                    const results = await Promise.all(promises);
                    validProducts = results.filter(p => p && p.isActive);
                }

                if (validProducts.length > 0) {
                    console.log(`[BestSellers] Using ${validProducts.length} admin selected products`);
                    setBestsellers(validProducts);
                } else {
                    // 3. Fallback Logic
                    console.log("[BestSellers] No admin selection, using fallback");
                    const fallback = await productService.getBestSellers(8);

                    // Fallback level 2: if not enough bestsellers, just fill with recent
                    if (fallback.length < 4) {
                        const recent = await productService.getRecentProducts(8);
                        const combined = [...fallback];
                        const existing = new Set(combined.map(p => p.id));
                        recent.forEach(p => {
                            if (!existing.has(p.id) && combined.length < 8) {
                                combined.push(p);
                            }
                        });
                        setBestsellers(combined);
                    } else {
                        setBestsellers(fallback);
                    }
                }
            } catch (error) {
                console.error("Error fetching bestsellers:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBestsellers();
    }, []);

    if (bestsellers.length === 0 && !loading) return null;

    return (
        <ProductSliderSection
            title={t('home.bestsellers.title')}
            subtitle={t('home.bestsellers.subtitle')}
            products={bestsellers}
            bgColor="bg-transparent"
        />
    );
};

export default BestsellersSection;
